export default function setToastSlice(state, action) {
	const newItem = {
		title: action.payload.title,
		description: action.payload.description,
		type: action.payload.type,
	};

	return {...state, toast: [...state.toast, newItem]};
}